import { Injectable } from '@angular/core';
import { SsoAuthService } from '../../ecan/sso-auth.service';
import { UserService } from '../../shared/api/users/user.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileUpdateService {

  constructor(
    private ssoAuthService: SsoAuthService,
    private userService: UserService) {
  }

  public init() {
    this.ssoAuthService.registerEventCallback('authenticated', () => this.onAuthenticated());
  }

  private onAuthenticated() {
    this.userService.updateProfile().subscribe();
  }
}
